"use strict";

var _defineProperty = require("/data/app/node_modules/babel-preset-gatsby/node_modules/@babel/runtime/helpers/defineProperty");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var CUSTOM_PROPERTY_NAME = '--aspect-ratio';

var AspectRatio = function AspectRatio(props) {
  var ratio = props.ratio,
      style = props.style,
      children = props.children,
      otherProps = _objectWithoutPropertiesLoose(props, ["ratio", "style", "children"]); // eslint-disable-line no-unused-vars


  var newStyle = _extends({}, style, _defineProperty({}, CUSTOM_PROPERTY_NAME, "(" + ratio + ")"));

  return _react["default"].createElement("div", _extends({
    style: newStyle
  }, otherProps), children);
};

AspectRatio.defaultProps = {
  className: 'react-aspect-ratio-placeholder',
  ratio: 1
};
var _default = AspectRatio;
exports["default"] = _default;